var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgH = function SvgH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 69,
    viewBox: "0 0 40 68.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2 35.5a13.752 13.752 0 0 0-2.7-5.4 14.091 14.091 0 0 0-4.9-3.8 16.683 16.683 0 0 0-7.3-1.4 15.05 15.05 0 0 0-6.3 1.2v9a12.7 12.7 0 0 1 3.4-.5 6.917 6.917 0 0 1 4.4 1.3 8.2 8.2 0 0 1 2.4 3.2 14.328 14.328 0 0 1 .9 4.1c.1 1.5.2 2.8.2 4V67a1.09 1.09 0 0 0 1 1.1h8.6A1.11 1.11 0 0 0 40 67V41.9a22.929 22.929 0 0 0-.8-6.4",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 16.1a1.347 1.347 0 0 0-1.3-1.4H3.2A1.347 1.347 0 0 0 1.8 16v12.4h9Zm-7.5-3.4V1.4A1.34 1.34 0 0 1 4.1.1a1.4 1.4 0 0 1 1.5.3L8.2 3a4 4 0 0 1 1.2 2.9v6.7ZM12.8 30a1.538 1.538 0 0 0-1.5-1.5H1.5A1.538 1.538 0 0 0 0 30v36.6a1.538 1.538 0 0 0 1.5 1.5h9.8a1.538 1.538 0 0 0 1.5-1.5Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};

export default SvgH;